module.exports = {"failed":"Queste credenziali non corrispondono ai dati registrati.","throttle":"Troppi tentativi di accesso. Riprova tra :seconds secondi"};